var i;!function(i){i.public="public",i.private="private"}(i||(i={}));export{i as FileVisibilityStatusEnum};